// A detached occurrence is an occurrence of a recurring appointment edited singularly: it is stored with its own id
// and keeps the id of the recurring appointment as recurrence id (a generated occurrence has the same id of both)
export function isDetachedOccurrence(appointment) {
    if (appointment?.Id == undefined || appointment.Id === "")
        return false;
    if (appointment.RecurrenceID == undefined || appointment.RecurrenceID === "")
        return false;
    return +appointment.Id !== +appointment.RecurrenceID;
}
